/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The default number of products returned by getProducts */
  static #MAX_PRODUCTS = 4;
  /** @static @constant {number} The maximum number of products to store (covers the recently viewed section) */
  static #MAX_STORED_PRODUCTS = 12;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts(this.#MAX_STORED_PRODUCTS);

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_STORED_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @param {number} [limit] - The maximum number of products to return (defaults to 4).
   * @returns {string[]} The list of viewed products, most recent first.
   */
  static getProducts(limit = this.#MAX_PRODUCTS) {
    /** @type {string[]} */
    let viewedProducts = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (Array.isArray(parsed)) viewedProducts = parsed;
    } catch {
      viewedProducts = [];
    }

    return viewedProducts.slice(0, limit);
  }
}
